import { createContext } from "react";

export const ExpeditingFiltersContext = createContext({
  filters: {},
});
